import { render, staticRenderFns } from "./DiscussionWorkSelector.vue?vue&type=template&id=0a3578d3&scoped=true&"
import script from "./DiscussionWorkSelector.vue?vue&type=script&lang=js&"
export * from "./DiscussionWorkSelector.vue?vue&type=script&lang=js&"
import style0 from "./DiscussionWorkSelector.vue?vue&type=style&index=0&id=0a3578d3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3578d3",
  null
  
)

export default component.exports